import type { LandingHeroCopy, PublicProductSummary } from '@repo/api-contracts';
import { storeProductPath } from '@/shared/config';
import { formatCount, formatKrw } from '@/shared/lib';
import type { HeroSlideCopy } from './hero-slide-item';

/** 연결 상품만 있을 때의 머리말. 배너 문구도 상품도 없으면 머리말을 붙이지 않는다. */
const PRODUCT_EYEBROW = '추천 상품';
const PRODUCT_CTA_LABEL = '보기';

const NO_COPY: LandingHeroCopy = {
  eyebrow: null,
  title: null,
  subtitle: null,
  ctaLabel: null,
  ctaHref: null,
};

/**
 * 히어로 문구를 필드마다 고른다 — 배너에 직접 입력한 문구가 먼저, 비었으면 연결 상품 정보.
 * 작은 라벨 ← "추천 상품", 큰 문구 ← 상품명, 보조 문구 ← "최소 N개 · 개당 N원부터", 버튼 ← "보기"·상품 상세.
 * 버튼 문구·링크는 짝으로만 저장되므로 버튼은 통째로 고른다. 고른 결과가 모두 비면 null(사진만).
 */
export const resolveHeroCopy = (
  copy: LandingHeroCopy | null,
  product: PublicProductSummary | null,
): HeroSlideCopy | null => {
  const own = copy ?? NO_COPY;
  const ownCta =
    own.ctaLabel !== null && own.ctaHref !== null
      ? { label: own.ctaLabel, href: own.ctaHref }
      : null;
  const resolved: HeroSlideCopy = {
    eyebrow: own.eyebrow ?? (product === null ? null : PRODUCT_EYEBROW),
    title: own.title ?? product?.name ?? null,
    subtitle:
      own.subtitle ??
      (product === null
        ? null
        : `최소 ${formatCount(product.minOrderQty)}개 · 개당 ${formatKrw(product.baseUnitPrice)}부터`),
    cta:
      ownCta ??
      (product === null ? null : { label: PRODUCT_CTA_LABEL, href: storeProductPath(product.id) }),
  };
  const isEmpty =
    resolved.eyebrow === null &&
    resolved.title === null &&
    resolved.subtitle === null &&
    resolved.cta === null;

  return isEmpty ? null : resolved;
};
